import { render, staticRenderFns } from "./Table_Order.vue?vue&type=template&id=a60fba74&"
import script from "./Table_Order.vue?vue&type=script&lang=js&"
export * from "./Table_Order.vue?vue&type=script&lang=js&"
import style0 from "./Table_Order.vue?vue&type=style&index=0&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports